import React, { useState } from 'react';

const users = [
  { id: 1, name: 'Jan Jansen', email: 'jan@example.nl', role: 'admin', joined: '2026-01-15' },
  { id: 2, name: 'Marie de Vries', email: 'marie@example.nl', role: 'user', joined: '2026-02-20' },
  { id: 3, name: 'Pieter Bakker', email: 'pieter@example.nl', role: 'user', joined: '2026-03-01' },
];

export default function AdminUsers() {
  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold mb-8">Gebruikers beheren</h1>
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Naam</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">E-mail</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Rol</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Lid sinds</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Acties</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id} className="border-t hover:bg-gray-50">
                <td className="px-6 py-4">{user.name}</td>
                <td className="px-6 py-4 text-gray-600">{user.email}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-sm ${user.role === 'admin' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>
                    {user.role}
                  </span>
                </td>
                <td className="px-6 py-4 text-gray-600">{user.joined}</td>
                <td className="px-6 py-4">
                  <button className="text-blue-600 hover:text-blue-800 mr-4">Bewerk</button>
                  <button className="text-red-600 hover:text-red-800">Verwijder</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
